import Api from './Api';

const all = (payload) => {
    const path = '/news-letters';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const sendNewsLetter = (payload) => {
    return Api.postRequest({
        endpoint: '/news-letter/send-news-letter',
        method: 'POST',
        data: payload
    });
};

export default {
    all,
    sendNewsLetter
};
